<template>
  <div>
    <div class="sidenav-container">
      <div class="sidenav">
        <!-- <EmailSettingsLayout active="EmailSettings"></EmailSettingsLayout> -->
        <EmailSettingsLayout></EmailSettingsLayout>
      </div>

      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <!-- Validation for sales -->
        <b-row class="px-3 border-bottom">
          <b-col cols="6" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >{{ $route.query.tns_type || 'Customer Statement' }}</h2>
          </b-col>

          <b-col cols="6" class="text-right px-pad">
            <b-button
              :to="{name:'EmailCreate',query:{tns_type:$route.query.tns_type}}"
              variant="primary"
              size="sm"
              class="mr-2"
            >New</b-button>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block pb-4"
          style="padding-left:17px !important;padding-right:17px !important;overflow-y: scroll;height: calc(100vh - 142px);overflow-x:hidden"
        >
          <!-- Validation Message -->
          <b-form @submit.prevent="onSubmit">
            <div class="page">
              <b-row>
                <b-col class="px-0">
                  <div class="table-responsive">
                    <table class="table table-hover index-table statement-table">
                      <thead>
                        <th style="padding-left:1.4rem !important;width:200px !important">Name</th>
                        <th style="width:250px !important;">Subject And Content</th>
                        <th style="width:60px !important;padding-right:1.4rem !important"></th>
                      </thead>
                      <tbody>
                        <tr v-for="(item,index) in list" :key="item.id">
                          <td
                            class="text-link"
                            style="padding-left:1.4rem !important;width:200px !important"
                          >
                            <router-link
                              :to="{name:'EmailUpdate',params:{id : item.template_id },query:{tns_type:$route.query.tns_type}}"
                            >
                              <span class="text pr-3">{{ item.template_name }}</span>
                            </router-link>
                            <p class="m-0 mt-4" v-if="item.is_default==1">
                              <b-badge variant="primary" size="xs">Default</b-badge>
                            </p>
                          </td>
                          <td style="width:250px !important;">
                            <span class="text pr-3">{{ item.template_subject }}</span>
                            <span class="d-block text-link mt-4">
                              <router-link
                                :to="{name:'EmailUpdate',params:{id : item.template_id },query:{tns_type:$route.query.tns_type}}"
                              >Show mail content</router-link>
                            </span>
                          </td>
                          <td class="align-middle" tyle="padding-right:1.4rem !important">
                            <b-button
                              v-if="item.is_default==1"
                              :to="{name : 'EmailCreate',query:{clone_id :item.template_id,tns_type:$route.query.tns_type}}"
                              variant="light"
                              size="sm"
                              title="delete"
                              class="ml-2 mr-2"
                            >Clone</b-button>
                            <b-button
                              variant="light"
                              size="sm"
                              title="delete"
                              v-if="item.is_default==1"
                              @click="handlingapprovingmodal({
                          content : 'Are you sure you want to delete this template ?',
                          title : 'Delete Mail template',
                          module:'settings/deletemailtemplate',
                          data:JSON.stringify({
                            id : item.template_id
                          }),
                          RoutePlace:'AmcContract',
                          isRoute:'false',
                          type: 'delete'
                })"
                            >
                              <i class="glyphicon glyphicon-trash"></i>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </div>
      </div>
    </div>
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
      v-on:setSuccessHandlingModal="getSuccessHandlingModal"
    />
  </div>
</template>
 <script>
import EmailSettingsLayout from "@/components/Layout/EmailSettingsLayout";
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import $ from "jquery";
import vSelect from "vue-select";
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: { vSelect, EmailSettingsLayout },
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      index_value: "",
      error_show: false, // to show the error message
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      submitted: false
    };
  },
  methods: {
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    getSuccessHandlingModal(ev) {
      if (this.globalmodaltype == "delete") {
        if (ev.status == 200) {
          this.$router.push({
            name: "EmailSettings",
            query: {
              update: !this.$route.query.update
            }
          });
        }
      }
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    var tns_type = routeTo.query.tns_type || "Customer Statement";
    routeTo.query.tns_type = tns_type;
    store
      .dispatch(
        "settings/fetchmaildetails",
        JSON.stringify({
          tns_type: tns_type
        })
      )
      .then(() => {
        next();
      });
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    var tns_type = routeTo.query.tns_type || "Customer Statement";
    routeTo.query.tns_type = tns_type;
    store
      .dispatch(
        "settings/fetchmaildetails",
        JSON.stringify({
          tns_type: tns_type
        })
      )
      .then(() => {
        next();
      });
  },
  computed: {
    ...mapState({
      list: state => state.settings.list
    })
  }
};
</script>
<style scoped>
.bg-transparent {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.form-check-inline {
  display: block !important;
}
</style>
